import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "😍", key: "roomTransformed" },
  { emoji: "😮", key: "guestsImpressed" },
  { emoji: "😌", key: "lovedWakingUpToIt" },
  { emoji: "📦", key: "clutterGone" },
]

export default function HomeSuccessSignalPage() {
  return (
    <RadioCardListPage translationKey="homeSuccessSignal" options={OPTIONS} />
  )
}
